import * as React from 'react'
import {Toast, Modal} from 'antd-mobile'
import {createHashHistory} from 'history'

import * as api from '@services/api'
import loading from '@utils/loading'

Toast.config({duration: 2.5, mask: false})

/**
 * 扩展组件/store类以方便调用
 * 集成api, 公用组件
 */

export class ComponentExt<P = {}, S = {}> extends React.Component<P, S> {
    protected readonly api = api
    protected readonly $toast = Toast
    protected readonly $modal = Modal
    protected readonly history = createHashHistory()
    protected readonly showLoading = () => loading.showLoading()
    protected readonly hideLoading = () => loading.hideLoading()
    protected readonly goBack = (): void => {
        this.history.goBack()
    }
    protected readonly goToPath = (url: string): void => {
        if (url.indexOf('ms-') > -1) {
            window.open(url, '_target')
        } else {
            this.history.push(url)
        }
    }
    protected readonly replacePath = (url) => {
        this.history.replace(url)
    }
}

export class StoreExt {
    protected readonly api = api
    protected readonly $toast = Toast
    protected readonly $modal = Modal
    protected readonly history = createHashHistory()
    protected readonly showLoading = () => loading.showLoading()
    protected readonly hideLoading = () => loading.hideLoading()
    protected readonly goBack = (): void => {
        this.history.goBack()
    }
    protected readonly goToPath = (url: string): void => {
        if (url.indexOf('ms-') > -1) {
            window.open(url, '_target')
        } else {
            this.history.push(url)
        }
    }
    protected readonly replacePath = (url) => {
        this.history.replace(url)
    }
}
